import { ApplicationElement, html } from '@effectivastudio/lit-components';
import '@effectivastudio/lit-components/components/icon/element.js';

import style from './style.lit.css';

/**
 * Button for opening options not currently shown.
 *
 */

export default class ButtonMore extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  render() {
    return html`
      <button aria-label="toggle menu">
        <ef-icon name="ellipsis"></ef-icon>
      </button>
    `;
  }
}

customElements.get('xs-btn-more') ||
  customElements.define('xs-btn-more', ButtonMore);
